import { debounce } from "lodash";

function toggleMobileMenu() {
  const headerContent = document.querySelector(".header__content");
  if (headerContent.classList.contains("header__content_open")) {
    headerContent.classList.remove("header__content_open");
  } else {
    headerContent.classList.add("header__content_open");
  }
}

window.toggleMobileMenu = toggleMobileMenu;

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}

window.scrollToTop = scrollToTop;

function getScrollPercent() {
  const h = document.documentElement,
    b = document.body,
    st = "scrollTop",
    sh = "scrollHeight";
  return (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100;
}


function updateHeaderScrollProgressBar() {
  const progressBar = document.querySelector(".header__scroll-progress");

  progressBar.style.width = getScrollPercent() + "%";
}

window.addEventListener("scroll",
  debounce(updateHeaderScrollProgressBar, 15)
);
